import { Entypo } from "@expo/vector-icons";
import { useAppSelector } from "hooks/useAppSelector";
import React from "react";

interface ChevronProps {
  direction?: "right" | "left" | "down" | "up";
  color?: string;
  size?: number;
  [keys: string]: any;
}
const Chevron: React.FC<ChevronProps> = ({
  direction = "right",
  color = "rgba(0,0,0,.54)",
  size = 24,
  ...rest
}) => {
  const theme = useAppSelector((state) => state.theme.theme);

  return (
    <Entypo
      name={`chevron-${direction}`}
      size={size}
      color={theme === "dark" ? "white" : color}
      {...rest}
    ></Entypo>
  );
};

export default Chevron;
